import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=71bbda2d&scoped=true&"
import script from "./SvgImage.vue?vue&type=script&lang=js&"
export * from "./SvgImage.vue?vue&type=script&lang=js&"
import style0 from "./SvgImage.vue?vue&type=style&index=0&id=71bbda2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bbda2d",
  null
  
)

export default component.exports